import { ExternalLink } from 'lucide-react';

export function ProductionLinkButton() {
  const previewUrl = 'https://web-konrad-search-a7k2m-preview.calmrock-e43e2cd7.eastus2.azurecontainerapps.io';
  const productionUrl = 'https://web-konrad-search-a7k2m.calmrock-e43e2cd7.eastus2.azurecontainerapps.io';

  const currentHost = window.location.hostname;
  
  // Determine target URL and button label based on current environment
  let targetUrl: string;
  let buttonLabel: string;
  
  if (currentHost.includes('localhost')) {
    targetUrl = previewUrl;
    buttonLabel = 'Preview';
  } else if (currentHost.includes('preview')) {
    targetUrl = productionUrl;
    buttonLabel = 'Production';
  } else {
    targetUrl = previewUrl;
    buttonLabel = 'Preview';
  }

  return (
    <button
      data-component="ProductionLinkButton"
      onClick={() => window.open(targetUrl, '_blank', 'noopener,noreferrer')}
      className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:border-gray-400 transition-colors"
      title={`Open ${buttonLabel} Environment`}
    >
      <ExternalLink className="w-4 h-4" />
      <span>{buttonLabel}</span>
    </button>
  );
}
